// extracted by mini-css-extract-plugin
module.exports = {"root":"survey_root__JcpHz","section":"survey_section__nyw5H"};